import React from 'react';
import { AnimatePresence, motion } from 'motion/react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faCircleCheck,
  faCircleExclamation,
  faCircleInfo,
  faTriangleExclamation,
} from '@fortawesome/free-solid-svg-icons';
import styles from './FeedbackMessage.module.css';
import Spinner from './Spinner';
import { fadeUp } from '../../utils/motion';

const ICONS = {
  success: faCircleCheck,
  error: faCircleExclamation,
  warning: faTriangleExclamation,
  info: faCircleInfo,
};

const TYPES = ['success', 'error', 'warning', 'info', 'loading'];

/**
 * Mensaje de estado consistente (éxito / error / aviso / info / carga) con icono.
 * Los errores usan role="alert" (assertive); el resto role="status" (polite).
 * Si `children` es falsy no renderiza nada y la salida se anima.
 */
export default function FeedbackMessage({ type = 'info', children, className = '' }) {
  const t = TYPES.includes(type) ? type : 'info';
  const isError = t === 'error';
  return (
    <AnimatePresence initial={false}>
      {children ? (
        <motion.div
          key={t}
          className={`${styles.msg} ${styles[t]} ${className}`}
          role={isError ? 'alert' : 'status'}
          aria-live={isError ? 'assertive' : 'polite'}
          variants={fadeUp}
          initial="hidden"
          animate="visible"
          exit="exit"
        >
          {t === 'loading' ? (
            <Spinner size="xs" inline />
          ) : (
            <FontAwesomeIcon icon={ICONS[t]} className={styles.icon} aria-hidden="true" />
          )}
          <span className={styles.text}>{children}</span>
        </motion.div>
      ) : null}
    </AnimatePresence>
  );
}
